import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Typography, useTheme, IconButton } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CloseIcon from '@mui/icons-material/Close';
const UploadComponentMulti = ({ formik, name }) => {
  const theme = useTheme();

  // Dropzone 핸들러: 선택된 파일을 formik의 해당 name 필드에 직접 저장
  const onDropHandler = (files) => {
    if (files && files.length > 0) {
      // 💡 [name]을 키로 사용하여 부모가 전달한 필드명(예: companyCBR)에 바로 저장
      formik.setFieldValue(name, files[0]);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onDropHandler,
    multiple: false, // 단일 파일 모드
    maxSize: 1000000000, // 약 1GB
  });

  // 💡 formik.values.file 대신 formik.values[name]을 참조하여 개별 상태 표시
  const currentFile = formik.values[name];
  const hasFile = Boolean(currentFile);
  const handleClear = (e) => {
    e.stopPropagation(); // 💡 중요: 부모의 Dropzone 클릭 이벤트 전파 방지
    formik.setFieldValue(name, ''); // 값 초기화
  };

  return (
    <Box
      {...getRootProps()}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '40px',
        border: `1px solid ${
          isDragActive ? theme.palette.primary.main : theme.palette.divider
        }`,
        borderRadius: '4px',
        p: '4px 8px',
        backgroundColor: '#fff',
        cursor: 'pointer',
        transition: 'border-color 0.2s',
        '&:hover': { 
          borderColor: theme.palette.text.primary 
        },
      }}
    >
      <input {...getInputProps()} />

      <Typography
        variant="body2"
        sx={{
          flexGrow: 1,
          color: hasFile ? 'text.primary' : 'text.disabled',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          mr: 1
        }}
      >
        {hasFile 
          ? currentFile.name // 선택된 파일의 이름 표시
          : "파일을 드래그하거나 클릭하여 선택하세요."
        }
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {hasFile && (
          <IconButton 
            size="small" 
            onClick={handleClear}
            sx={{ mr: 0.5, p: 0.2 }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
        <AttachFileIcon 
          fontSize="small" 
          color={hasFile ? "primary" : "action"} 
        />
      </Box>
    </Box>
  );
};

export default UploadComponentMulti;
